import * as React from 'react';

import * as styles from './CarouselItemWrapper.css';

interface ICarouselItemWrapperProps {
  onClick?(): void;
  dataName?: string;
}

export const CarouselItemWrapper = React.forwardRef(
  (
    { onClick, children, dataName }: React.PropsWithChildren<ICarouselItemWrapperProps>,
    ref: React.Ref<HTMLDivElement> | undefined,
  ) => {
    return (
      <div ref={ref} className={styles['container']} onClick={onClick} data-name={dataName}>
        <div className={styles['content']}>{children}</div>
      </div>
    );
  },
);

CarouselItemWrapper.displayName = 'CarouselItemWrapper';
